const _ = require("lodash");

export function initHeader() {
    const d = document;
    const b = document.body;
    const e = d.getElementById("header");
    window.addEventListener( "scroll", _.throttle(() => {scrollFunction(d, b, e)}, 150) );
    window.addEventListener( "load", function() {
        scrollFunction(d, b, e);
    } );
}

export function scrollFunction(d, b, e) {
    const offset = 56;
    if (b.scrollTop > offset || d.documentElement.scrollTop > offset) {
        if (e.classList.contains("scroll-on")) {
            return;
        }
        d.getElementById("header").classList.add("scroll-on");
    } else {
        if (e.classList.contains("scroll-on")) {
            d.getElementById("header").classList.remove("scroll-on");
        }
    }
}
